import { cloneDeep } from 'lodash';

export interface IDeploymentStrategy {
  key: string;
  label: string;
  description: string;
  providerRestricted?: boolean;
  additionalFields?: string[];
  additionalFieldsTemplateUrl?: string;
  initializationMethod?: (command: any) => void;
}

export class DeploymentStrategyRegistrar {

  private strategies: IDeploymentStrategy[] = [];
  private providerRegistry: {[key: string]: string[]} = {};

  public registerStrategy(strategy: IDeploymentStrategy): void {
    this.strategies.push(strategy);
    this.configureProviderRegistryEntry(strategy.key);
  }

  public listStrategies(cloudProvider: string): IDeploymentStrategy[] {
    return this.strategies
      .filter(s => !s.providerRestricted || this.providerRegistry[s.key].includes(cloudProvider))
      .map(cloneDeep);
  }

  public registerProvider(provider: string, strategies: string[]) {
    strategies.forEach(strategy => {
      this.configureProviderRegistryEntry(strategy);
      this.providerRegistry[strategy].push(provider);
    });
  }

  public getStrategy(key: string): IDeploymentStrategy {
    return this.strategies.find(s => s.key === key);
  }

  private configureProviderRegistryEntry(key: string): void {
    if (!this.providerRegistry[key]) {
      this.providerRegistry[key] = [];
    }
  }
}

export const DeploymentStrategyRegistry = new DeploymentStrategyRegistrar();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/deploymentStrategy/deploymentStrategy.registry.ts